export default __webpack_public_path__ + "static/media/connect.80fe1f4c.gif";